import React, { Component } from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
// import {TableComp} from 'sz-react-utils'
import TableComp from "../../components/_utils/table";
import { getUrlPushWrapper, getUrlQuery } from "../../routes";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { FaUserEdit } from "react-icons/fa";
import moment from "moment";
import ListFollowUps from "../../components/_utils/listFollowUp";
import { RightsWrapper } from "../../components/_utils/utils";
import LeadImportExcel from '../../assets/samplesFiles/leadImport.xlsx'
import _ from 'lodash'
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Col,
  notification,
  Popconfirm,
  Row,
  Select,
  Tooltip,
  Drawer,
  Form
} from "antd";
import Request, { API_URL, LAPI_URL } from "../../request";
import Settings from "../../components/_utils/settings";
import lodash from "lodash";
import { connect } from "react-redux";
import styles from "../Student/inquiry/all/styles.less";
// import common from "../../common.less";
import LatestFollowUp from "../../components/_utils/latestFollowup";
import SMS from "../../components/communication/sms";
import WhatsAPPSMS from "../../components/communication/WhatsAppSms";
import EmailDrawer from "../../components/communication/emailDrawer";
// import ChangeBranch from ''
import ChangeBranch from "../Student/inquiry/all/changeBranch";
import ChangeQuickDetails from "../Student/inquiry/all/changeQuickDetails";

import { hideLoader, showLoader } from "../../modules/actions";

import rightAuth from "../../components/_utils/userRights";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let counsellingData = {};

let studentObj = {};

const { RangePicker } = DatePicker;

const Option = Select.Option;

let localUser = JSON.parse(localStorage.getItem('user'))

let desks = {
  'Front Desk': '/desk/update-counselling',
  'Registration Desk': '/registration/fees',
  'Application Desk': '/desk/allApplication-desk/update',
  'Visa Desk': '/desk/getVisa',
  'Claim Desk': '/desk/getClaim',
  'Operation Manager Desk': '/operation-manager-inquiry/update'
};

let userCheckBox = {};

@Form.create()
class AllReferrals extends Component {
  state = {
    count: 0,
    showFollowUp: false,
    studentId: null,
    allDesks: Settings.allDesks,
    deskNameObj: Settings.deskNameObj,
    deskId: "",
    counsellorId: "",
    counsellors: [],
    allCounsellor: [],
    allBranches: [],
    testTypeList: [],
    deleteLoading: false,
    branchId: "",
    deskColor: null,
    userCheckBox: {},
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    showDate: true,
    showRegiDate: false,
    time: {
      key: "time",
      $gte: "",
      $lt: "",
    },
    registrationTime: {
      $gte: "",
      $lt: "",
    },
    ratingArr: [],
    ratingsObject: [],
    modeArr: [],
    inquiryArr: ["COACHING", "STUDENT"],
    countryArr: [],
    drawer: false,
    drawerParam: null,
    isFollowUpOverdue: false,
    updateQuickDetailsDrawer: false,
    visible1: false
  };
  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showSMS: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeSMS = () => {
    this.setState({ showSMS: false });
  };
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showWhatsAppSms: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false });
  };
  closeEmail = () => {
    this.setState({ showEmail: false });
  };
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showEmail: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  deleteStudent = async (_id) => {
    this.setState({ deleteLoading: true });
    let x = await Request.deleteStudent({ _id: _id, atLevel: "Deleted" });
    this.setState({ deleteLoading: false });
    if (x && !x.error) {
      notification.success({
        message: "Deleted Successfully",
      });
      this.table.current.reload();
    } else {
      notification.error({ message: "Try again" });
    }
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then((resp) => {
        if (resp) {
          let temp = [{ display: "---Show All---", id: "" }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name;
            vv.id = vv._id;
            temp.push(vv);
            return temp;
          }, []);
          this.setState({ counsellors: resp.data });
        }
      })
      .catch((err) => { });
  }

  openFollowUps = (record) => {
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };

    this.setState({ showFollowUp: true });
  };
  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Neutral") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
    if (val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.deskId) {
        params.atLevel = this.state.deskId;
        params.page = 1;
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
        params.page = 1;
      }

      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
        params.page = 1;
      }
      if (this.state.singleRatingFilter) {
        params["counsellingDesk.rating"] = this.state.singleRatingFilter;
      }

      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: stringToDate.setHours(0, 0, 0),
          $lt: stringToDate.setHours(23, 59, 59),
        };
      } else {
        delete params.dateOfBirth;
      }

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }
      params.location = { $in: ['Associate Partner', 'Lead Referral', 'Employee Referral', 'External Referral'] }

      let data = await Request.getAllStudentList({
        ...params,
        regExFilters: ["studentName", "watsupp", "mobile"],
        InquiryDate: this.state.time,
        registrationTime: this.state.registrationTime,
      });

      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false,
          };
        }
      });

      this.setState({
        count: data.total,
        allBranches: data.allBranches,
        userCheckBox: userCheckBox,
      });
      resolve(data);
    });
  };


  closeFollowUp = () => {
    this.setState({ showFollowUp: false });
  };
  returnDeskName = (record) => {
    const deskConfig = Settings.allDesks;

    let findIn = lodash.find(deskConfig, (rr) => {
      return rr.name == record.atLevel;
    });

    if (findIn) {
      return (
        <div
          style={{
            backgroundColor: findIn.color,
            color: "white",
            padding: 3,
            display: "inline-block",
            fontWeight: "bold",
          }}
        >
          {
            localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
              <a
                style={{ color: 'white' }}
                size={"small"}
                href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
              >{Settings.deskNameObj[record.atLevel]}</a>
              :
              Settings.deskNameObj[record.atLevel]
          }
        </div>
      );
    } else {
      return <div>{record.atLevel}</div>;
    }
  };
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(
        moment(new Date()).format("YYYY-MM-DD[T00:00:00.000Z]")
      ).isAfter(followUp.followUpDate);
    }
  };

  componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);

    let singleRatingFilter = searchParams.get("rating");
    if (singleRatingFilter) {
      this.setState({ singleRatingFilter: singleRatingFilter });
    }
  }

  async componentDidMount() {
    await this.getAllRatings();
    await this.getAllSource();
    await this.getAllTestTypes();
    let {
      data: allCounsellor,
    } = await Request.loadCounsellorListForStudentRights({
      results: 10000,
    });
    this.setState({
      allCounsellor,
    });

    let {
      data: allOperationManager,
    } = await Request.getOperationManagerListForStudentRights({
      results: 10000,
    });
    this.setState({
      allOperationManager,
    });
  }
  getAllTestTypes = async () => {
    let response = await Request.getAllTestTypes({
      results: 1000,
      count: 1000
    });
    if (response && response.data) {
      let testTypeList = [];
      testTypeList.push({ value: 'NO', text: 'Never' })
      response.data.map((testTypeData) => {
        testTypeList.push({ value: testTypeData.testType, text: testTypeData.testType })
      })
      this.setState({
        testTypeList: testTypeList
      });
    }
  }
  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000,
    });
    let sourceObject = [];
    response.data &&
      response.data.map((source) => {
        sourceObject.push(source.sourceName);
      });
    this.setState({ modeArr: sourceObject });
  };

  handleStudentMove = async (data) => {
    let response = await Request.moveStudentToVisitorVisa(data);
    if (!response.error) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
  };

  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000,
    });
    let ratingsObject = [];
    response.data &&
      response.data.map((rating) => {
        ratingsObject[rating._id] = rating;
      });
    this.setState({ ratingArr: response.data, ratingsObject: ratingsObject });
  };

  loadCountry(callback) {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          lodash.each(resp.data, (vv) => {
            temp.push({
              text: vv.countryName,
              value: vv.countryName,
            });
          });
          return callback(temp);
        } else {
          return callback([]);
        }
      })
      .catch((err) => {
        return callback([]);
      });
  }

  chooseRangerPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        time: {
          key: "time",
          $gte: date[0],
          $lt: date[1],
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };
  chooseRegistrationPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        registrationTime: {
          $gte: date[0],
          $lt: date[1],
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };

  reload = () => {
    this.table.current.reload();
  };

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {

        let values = _.clone(valData)

        let x = null
        x = await Request.addInquiryThroughExcel(values.excelFile[0].response)

        if (!x.error) {
          notification.success({
            message: x.message
          })

          this.setState({ visible1: false })
          this.table.current.reload()
        } else {
          notification.error({
            message: x.message

          })
        }
      }
    })
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState(
      {
        isFollowUpOverdue: isFollowUpOverdue,
      },
      () => {
        this.table.current.reload();
      }
    );
  }

  render() {
    const { dispatch } = this.props;
    const {
      drawerParam,
      drawer,
      allDesks,
      inquiryArr,
      ratingsObject,
      allCounsellor = [],
      allOperationManager = [],
      countryArr = [],
      deleteLoading,
      allBranches = [],
      deskColor,
      userCheckBox,
      ratingArr,
      modeArr,
      deskNameObj,
      counsellors,
      testTypeList
    } = this.state;

    const inputTypes = {
      fields: [
        { label: 'Choose Excel File', key: 'excelFile', type: 'file', required: true }
      ]
    }
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 }
      }
    }

    const {
      form: { getFieldDecorator, getFieldValue }
    } = this.props

    let columns = [
      {
        title: "Action ",
        key: "operation",
        dataindex: "operation",
        right: rightAuth.checkRights("actionColumn.view"),
        width: 160,
        maxWidth: 200,
        render: (text, record) => (
          <React.Fragment>
            <span className={styles.userSelectCheckbox}>
              <Checkbox
                checked={
                  userCheckBox[record._id]
                    ? userCheckBox[record._id].isChecked
                    : false
                }
                onChange={(y) => {
                  this.selectUser(y, record._id);
                }}
              />
            </span>

            <RightsWrapper myRight={"FollowUps.view"}>
              <Tooltip title="Follow Ups">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() => this.openFollowUps(record)}
                  icon="calendar"
                />
              </Tooltip>
            </RightsWrapper>
            <Tooltip title="Click To Edit Details">
              {
                localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
                  <Button
                    className={styles.btn}
                    shape="circle"
                    size={"small"}
                    href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
                    icon="edit"
                  />
                  :
                  <Button
                    className={styles.btn}
                    shape="circle"
                    size={"small"}
                    href={"/documents?id=" + record._id}
                    icon="edit"
                  />
              }
            </Tooltip>
            <span>
              <Tooltip title="Change Student Branch ">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() =>
                    this.setState({ drawerParam: record, drawer: true })
                  }
                  icon="user"
                />
              </Tooltip>
            </span>
            {
              rightAuth.checkRights("changeStudentQuickDetails.view") ?
                <span>
                  <Tooltip title="Change Student Quick Details ">
                    <Button
                      className={styles.btn}
                      size={"small"}
                      shape="circle"
                      onClick={() =>
                        this.setState({ drawerParam: record, updateQuickDetailsDrawer: true })
                      }
                    >
                      <FaUserEdit />
                    </Button>
                  </Tooltip>
                </span>
                : null
            }

            {!record.movedToVisitorVisa ? (
              <RightsWrapper myRight={"moveStudentToVisitorVisaLead.view"}>
                <span>
                  <Tooltip title="Move Student for Visitor Visa ">
                    <Popconfirm
                      title="Are you sure to move student"
                      onConfirm={() => this.handleStudentMove(record)}
                    >
                      <Button
                        className={styles.btn}
                        size={"small"}
                        shape="circle"
                        icon="forward"
                      />
                    </Popconfirm>
                  </Tooltip>
                </span>
              </RightsWrapper>
            ) : null}
          </React.Fragment>
        ),
      },
      {
        title: "Photo",
        key: "profilePic",
        width: 55,
        dataIndex: "profilePic",
        right: rightAuth.checkRights("photoColumn.view"),
        render: (val) => {
          return <Avatar src={val} />;
        },
      },
      {
        title: "ID",
        key: "id",
        width: 100,
        dataIndex: "id",
        sorter: true,
        searchTextName: "id",
        right: rightAuth.checkRights("idColumn.view"),
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        width: 110,
        dataIndex: "studentName",
        sorter: true,
        searchTextName: "studentName",
        right: rightAuth.checkRights("nameColumn.view"),
        filterRegex: true,
        render: (item, record) => {
          return (
            <React.Fragment>
              <div
                className={
                  this.followUpExtendedDate(
                    record.followUp ? record.followUp : ""
                  )
                    ? styles.followUpExtendedDate
                    : ""
                }
              >
                <Tooltip>
                  <a
                    className={styles.btn}
                    target={"_blank"}
                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                  >
                    {item}
                  </a>
                </Tooltip>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        title: "Referred By",
        key: "location",
        width: 120,
        dataIndex: "location",
        right: rightAuth.checkRights("nameColumn.view"),
        // render: (item, record) => {
        //   return (
        //     <React.Fragment>
        //       <div
        //         className={
        //           this.followUpExtendedDate(
        //             record.followUp ? record.followUp : ""
        //           )
        //             ? styles.followUpExtendedDate
        //             : ""
        //         }
        //       >
        //         <Tooltip>
        //           <a
        //             className={styles.btn}
        //             target={"_blank"}
        //             href={`/inquiry/studentProfileDetails?id=${record._id}`}
        //           >
        //             {item}
        //           </a>
        //         </Tooltip>
        //       </div>
        //     </React.Fragment>
        //   );
        // },
      },
      {
        title: 'Referee Name',
        key: 'employeeId.name',
        width: 120,
        dataIndex: 'employeeId.name',
        right: rightAuth.checkRights("nameColumn.view"),
        render: (text, record) => {
          if (record.location === "Associate Partner") {
            return (
              <span>{record.associativePartnerId && record.associativePartnerId.branchName}</span>
            )
          } else if (record.location === "Employee Referral") {
            return (
              <span>{record.employeeId.name}</span>
            )
          } else if (record.location === "External Referral") {
            return (
              <span>{record.externalReferralName}</span>
            )
          }
        }
      },
      {
        title: "Passport Number",
        width: 120,
        key: "passportNumber",
        dataIndex: "profile.passportNumber",
        right: rightAuth.checkRights("passportNumber.view")
      },
      {
        title: "DOB",
        width: 100,
        sorter: true,
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        right: rightAuth.checkRights("dobColumn.view"),
        searchTextName: "D-M-Y",
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: 'Institute Student Id',
        key: 'instituteStudentId',
        dataIndex: 'instituteStudentId',
        searchTextName: 'instituteStudentId',
        filterRegex: true,
        render: (item, record) => {
          return record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.instituteStudentId ? record.visaDesk.selectedCourse.instituteStudentId : record.instituteStudentId ? record.instituteStudentId : ''
        },
        width: 120,
        right: rightAuth.checkRights("instituteStudentId.view"),
      },
      {
        title: "Test Type",
        width: 100,
        key: "testType",
        dataIndex: "testType",
        right: rightAuth.checkRights("testType.view"),
        filters: testTypeList ? testTypeList : [],
      },
      {
        title: "Student Register From ",
        width: 180,
        key: "studentRegisterFrom",
        dataIndex: "studentRegisterFrom",
        right: rightAuth.checkRights("studentRegisterFromColumn.view"),
        render: (val, record) => {
          return (
            <div>
              {record.studentRegisterFrom
                ? record.studentRegisterFrom
                : "Reception Desk"}
            </div>
          );
        },
      },
      {
        title: "At Stage",
        key: "atLevel",
        dataIndex: "atLevel",
        width: 150,
        sorter: true,
        right: rightAuth.checkRights("atStageColumn.view"),
        render: (val, record) => {
          return this.returnDeskName(record);
        },
      },
      {
        title: "Registration Date",
        width: 100,
        key: "moveDeskDate.moveToRegistrationDesk",
        dataIndex: "moveDeskDate.moveToRegistrationDesk",
        right: rightAuth.checkRights("registrationDateColumn.view"),
        width: 140,
        render: (text, record) => {
          return <div>{text ? moment(text).format("lll") : ""}</div>;
        },
      },

      {
        title: "Mobile",
        width: 100,
        key: "mobile",
        dataIndex: "mobile",
        searchTextName: "mobile",
        right: rightAuth.checkRights("mobileColumn.view"),
        filterRegex: true,
        render: (val, record) => {
          return (
            <div>
              {" "}
              {record.mobile &&
                record.mobile.length >= 10 &&
                rightAuth.checkRights("ShowClickToCall.view") ? (
                <Tooltip title="Start Call">
                  <Button
                    className="ant-btn ant-btn-primary"
                    onClick={(e) => {
                      dispatch(showLoader());
                      Request.callInitiate({
                        mobile: record.mobile,
                      }).then(({ data, error, message }) => {
                        dispatch(hideLoader());
                        if (!error) {
                          notification.success({
                            message: message,
                          });
                        } else {
                          notification.error({
                            message: message,
                          });
                        }
                      });
                    }}
                  >
                    Click To Call
                  </Button>
                </Tooltip>
              ) : (
                record.mobile
              )}
            </div>
          );
        },
      },
      {
        title: "WhatsApp",
        width: 140,
        key: "watsupp",
        dataIndex: "watsupp",
        searchTextName: "watsupp",
        right: rightAuth.checkRights("whatsAppColumn.view"),
        filterRegex: true,
        render: (val, record) => {
          return val && val.length == 10 ? (
            <Tooltip title="Share on Whatsapp">
              <a
                target={"_blank"}
                className="ant-btn ant-btn-primary"
                href={`http://api.whatsapp.com/send?phone=${val}&text=&source=&data=`}
              >
                Send WhatsApp
              </a>
            </Tooltip>
          ) : null;
        },
      },
      {
        title: "Mode",
        width: 100,
        key: "mode",
        right: rightAuth.checkRights("modeColumn.view"),
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Rating",
        width: 100,
        key: "counsellingDesk.rating",
        right: rightAuth.checkRights("ratingColumn.view"),
        filters:
          ratingArr &&
          ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
        render: (val, record) => {
          let ratingObject = ratingsObject[val];
          return (
            <div>
              {ratingObject ? (
                <div
                  className="antd-pro-containers-desk-counselling-all-styles-rating"
                  style={{
                    background: ratingObject.ratingColor,
                    borderColor: ratingObject.ratingColor,
                  }}
                >
                  {ratingObject.ratingName}
                </div>
              ) : (
                this.renderStatus(val)
              )}
            </div>
          );
        },
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        width: 110,
        right: rightAuth.checkRights("counsellorColumn.view"),
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Operation Manager",
        key: "operationManagerId",
        right: rightAuth.checkRights("operationManagerColumn.view"),
        width: 110,
        filters: allOperationManager.map((x) => ({
          value: x._id,
          text: x.name,
        })),
        render: (text, record) => {
          return (
            <div>
              {record.operationManagerId ? record.operationManagerId.name : ""}
            </div>
          );
        },
      },
      {
        title: "Branch",
        width: 100,
        key: "studentBranchId",
        right: rightAuth.checkRights("branchColumn.view"),
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "Preference",
        key: "preference",
        width: 110,
        searchTextName: "preference",
        right: rightAuth.checkRights("preferenceColumn.view"),
        filterRegex: true,
        render: (val, row) => {
          return row.totalPreference ? (
            <ul>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val.country}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      {
        title: "Follow Up",
        key: "followUp",
        width: 200,
        dataIndex: "followUp",
        right: rightAuth.checkRights("followUPColumn.view"),
        render: (text, record) => {
          return <LatestFollowUp info={text} />;
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        right: rightAuth.checkRights("lastUpdatedByColumn.view"),
        render: (text, record) => {
          return (
            <div>
              <div>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
      {
        title: "Action",
        key: "_id",
        dataindex: "_id",
        right: rightAuth.checkRights("actionColumn.view"),
        width: 100,
        render: (val, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"Student.delete"}>
              <Tooltip title="Delete Student ">
                <Popconfirm
                  title="Are you sure delete this student?"
                  onConfirm={() => {
                    this.deleteStudent(val);
                  }}
                  onCancel={() => {
                    console.log();
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    loading={deleteLoading}
                    className={styles.btn}
                    size={"small"}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
    ];
    columns = lodash.filter(columns, (x) => {
      return x.right == true;
    });

    return (
      <PageHeaderWrapper
        title={` STUDENTS LIST : ${this.state.count} `}
        followUpsCallback={this.followUpsCallback}
      >
        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}

        {drawer && (
          <ChangeBranch
            param={drawerParam}
            onClose={() => {
              this.setState({ drawer: false }, () => {
                this.table.current.reload();
              });
            }}
          />
        )}

        {this.state.updateQuickDetailsDrawer && (
          <ChangeQuickDetails
            param={drawerParam}
            onClose={() => {
              this.setState({ updateQuickDetailsDrawer: false }, () => {
                this.table.current.reload();
              });
            }}
          />
        )}

        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS
            counsellingData={counsellingData}
            onClose={this.closeWhatsSMS}
          />
        ) : null}

        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}

        {this.state.showEmail ? (
          <EmailDrawer
            counsellingData={counsellingData}
            onClose={this.closeEmail}
          />
        ) : null}

        <Card style={{ marginBottom: 10 }}>
          <Col span={9}>
            <h4>FILTER BY CREATED DATE</h4>
            <RangePicker
              key={this.state.showDate ? "78" : "326"}
              showTime={{ format: "HH:mm" }}
              format="YYYY-MM-DD"
              placeholder={["Start Date", "End Date"]}
              onChange={this.chooseRangerPicker}
              onOk={this.onOk}
            />
          </Col>
          <Col span={9}>
            <h4>FILTER BY REGISTRATION DATE</h4>
            <RangePicker
              key={this.state.showRegiDate ? "78" : "326"}
              showTime={{ format: "HH:mm" }}
              format="YYYY-MM-DD"
              placeholder={["Start Date", "End Date"]}
              onChange={this.chooseRegistrationPicker}
              onOk={this.onRegistrationOk}
            />
          </Col>
          <Col span={6}>
            <Button
              type={'primary'}
              style={{ textAlign: 'center' }}
              onClick={() => { this.setState({ visible1: true }) }}
            >Add Excel File</Button>
          </Col>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <div className={styles.filterBlock}>
            <div style={{ display: "flex" }}>
              {counsellors && counsellors.length ? (
                <div style={{ float: "left" }}>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16,
                    }}
                    showSearch={true}
                    value={this.state.counsellorId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={(counsellorId) => {
                      this.setState(
                        {
                          counsellorId: counsellorId && counsellorId.toString(),
                        },
                        () => {
                          setTimeout(() => {
                            this.table.current.reload();
                          }, 500);
                        }
                      );
                    }}
                  >
                    {counsellors.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.id}>
                          {val.display}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              ) : null}
              <Select
                allowClear
                style={{
                  width: 214,
                  paddingRight: 16,
                  paddingLeft: 9,
                  color: deskColor,
                }}
                value={deskNameObj[this.state.deskId]}
                placeholder="Select Desk"
                onChange={(deskId) => {
                  if (deskId) {
                    deskId = JSON.parse(deskId);
                    this.setState(
                      {
                        deskId: deskId && deskId.name.toString(),
                        deskColor: deskId.color,
                      },
                      () => {
                        this.table.current.reload();
                      }
                    );
                  } else {
                    this.setState({ deskId: "", deskColor: "" }, () => {
                      this.table.current.reload();
                    });
                  }
                }}
              >
                {allDesks.map((val, idn) => {
                  return (
                    <Option key={idn} value={JSON.stringify(val)}>
                      <Row>
                        <Col span={20}> {deskNameObj[val.name]} </Col>
                        <Col span={4}>
                          <div
                            style={{
                              paddingTop: 10,
                              backgroundColor: val.color,
                            }}
                          />
                        </Col>
                      </Row>
                    </Option>
                  );
                })}
              </Select>
            </div>
            <div className={styles.myBtnGroup}>
              <Button
                className={styles.btn}
                type="primary"
                onClick={() => this.showEmail()}
              >
                Send E-mail
              </Button>

              <Button
                type="primary"
                className={styles.btn}
                onClick={() => this.showSMS()}
              >
                Send SMS
              </Button>

              <Button
                type="primary"
                className={styles.btn}
                onClick={() => this.showWhatsAppSms()}
              >
                {" "}
                Whatsapp
              </Button>

              <Button
                className={styles.btn}
                onClick={() => this.selectAllUserFxn()}
              >
                Select Visible
              </Button>

              <Button
                className={styles.btn}
                onClick={() => this.unselectAllUserFxn()}
              >
                Unselect Visible
              </Button>
            </div>
          </div>
        </Card>

        <Card bordered={true}>
          <TableComp
            id={"allstudents"}
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params, columns)}
            extraProps={{ scroll: { x: 1800 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
        {this.state.visible1 && <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              visible1: false
            })
          }}
          visible={this.state.visible1}
          width={500}>
          <div>
            <Card bordered={true}>
              <div>

                <Form onSubmit={this.handleSubmit} {...formItemLayout} style={{ marginTop: 8 }}>
                  <GetAllFormFields apiurl={LAPI_URL}
                    inputSchema={inputTypes}
                    getFieldDecorator={getFieldDecorator} />

                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginLeft: '10%' }}
                    loading={this.state.loading}>
                    UPLOAD

                  </Button>

                  <a href={LeadImportExcel} download={'lead-sample.xlsx'}>
                    <Button
                      type="default"
                      style={{ marginLeft: '10%' }}
                      loading={this.state.loading}>
                      DOWNLOAD SAMPLE FILE
                    </Button>
                  </a>
                </Form>

              </div>


            </Card>
          </div>
        </Drawer>}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllReferrals);
